import React, { useEffect } from 'react';
import { useAuth } from '../../lib/AuthContext';
import { useChatStore } from '../../stores/chatStore';

export interface ChatStoreSynchronizerProps {
  /** Passed from WorkspaceProvider so this component never calls useWorkspace (avoids HMR / ordering issues). */
  selectedWorkspaceId: string | null;
}

/**
 * Bridges Auth + workspace selection to the Zustand chat store.
 * Must render as a child of WorkspaceContext.Provider (workspace id comes from props).
 */
export const ChatStoreSynchronizer: React.FC<ChatStoreSynchronizerProps> = ({
  selectedWorkspaceId,
}) => {
  const { getBackendUserId, isAuthenticated, user } = useAuth();
  const setContext = useChatStore((state) => state.setContext);

  useEffect(() => {
    const backendUserId = getBackendUserId();
    let effectiveUserId: string | null = null;

    if (backendUserId) {
      effectiveUserId = backendUserId;
    } else if (isAuthenticated && user) {
      effectiveUserId = user.id;
    }

    if (effectiveUserId) {
      setContext(effectiveUserId, selectedWorkspaceId);
    }
  }, [getBackendUserId, isAuthenticated, user, selectedWorkspaceId, setContext]);

  return null;
};
